"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterFromObjectAndExpression = exports.createFilterFromFilterObject = exports.createFilterFromExpression = exports.txnListMetrics = exports.downloadRegisterToCSV = exports.fieldIsEditable = exports.fieldIsMoveable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const luxon_1 = require("luxon");
const memoizeWithKey_1 = require("utils/memoizeWithKey");
const transactions_1 = require("companion-app-components/flux/transactions");
const utils_1 = require("data/transactions/utils");
const utils_2 = require("utils/utils");
const searchFilter_1 = require("data/transactions/searchFilter");
const transactionsConfig = __importStar(require("./transactionsConfig"));
const fieldIsMoveable = (field) => {
    const items = (0, utils_2.findInObject)(transactionsConfig.fieldData, (x, k) => k === field);
    if (items.length > 0) {
        return items[0].moveable;
    }
    return false;
};
exports.fieldIsMoveable = fieldIsMoveable;
const fieldIsEditable = (txn, fld, props) => {
    var _a;
    const stateInfo = (0, utils_1.getTxnStateInfo)(txn);
    const skipAmounts = (txn.cpData && !props.editDownloaded) || props.showSplitWindow;
    let fieldNotActive = !props.headerFields.includes(fld) ||
        !props.regEditableFields.includes(fld) ||
        (fld === 'account' && (props.accountIds.size <= 1 ||
            (stateInfo.entry === 'bank' || stateInfo.entry === 'matched'))) ||
        (fld === 'balance' && (!props.editRunningBalance || props.accountIds.size > 1)) ||
        (!props.txnCancelExtraColumn && fld === 'close') ||
        (props.showAccountColors && fld === 'account') ||
        ((0, utils_1.isUnacceptedScheduledTxn)(txn) && transactionsConfig.recurringEditable.indexOf(fld) < 0) ||
        (fld === 'select' && stateInfo.status === 'UPCOMING' && !(0, utils_1.isNextScheduledInstance)(txn, props.scheduledTransactionsById)) ||
        (!props.showAccountColors && fld === 'accountColor');
    fieldNotActive = fieldNotActive || (skipAmounts && (fld === 'amount' || fld === 'income' || fld === 'expense')) ||
        (transactions_1.transactionsUtils.isSplitTxn(txn) && (fld === 'tags' || fld === 'category')) || (props.showSplitWindow && fld === 'category');
    // Condition for account not synced case
    if ((fld === 'menu' || fld === 'state') && ((_a = txn === null || txn === void 0 ? void 0 : txn.coa) === null || _a === void 0 ? void 0 : _a.type) === 'ACCOUNT' && props.allAccountIds && !props.allAccountIds.includes(txn.coa.id)) {
        fieldNotActive = true;
    }
    return !fieldNotActive;
};
exports.fieldIsEditable = fieldIsEditable;
const createCSVRow = (regColumns, txn, longCats) => {
    const row = [];
    regColumns.forEach((field) => {
        row.push(`"${(0, searchFilter_1.getFieldString)(field, txn, longCats)}"`);
    });
    return row;
};
const createCSVSplitRow = (regColumns, txn, longCats) => {
    const row = [];
    regColumns.forEach((field) => {
        if (field === 'category' || field === 'amount') {
            row.push(`"${(0, searchFilter_1.getFieldString)(field, txn, longCats)}"`);
        }
        else {
            row.push('');
        }
    });
    return row;
};
const processTxnList = (props, headers, data, txnList) => {
    txnList.forEach((txn) => {
        data.push(createCSVRow(headers, txn, props.longCats));
        if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
            txn.split.items.forEach((item) => {
                data.push(createCSVSplitRow(headers, item, props.longCats));
            });
        }
    });
};
const convertRegViewToArrays = (props) => {
    const data = [];
    const headers = Object.keys((0, utils_2.filterByKeys)(transactionsConfig.fieldData, (x) => x.exportable));
    const idxNotes = headers.indexOf('notes');
    if (idxNotes !== -1) {
        headers[idxNotes] = 'memo';
    }
    // Per Kelly J, if there are selected transactions, download those, otherwise
    // download all the current acctTxns
    if (props.uiState.selectedTxns && props.uiState.selectedTxns.size > 0) {
        processTxnList(props, headers, data, props.uiState.selectedTxns);
    }
    else {
        props.acctTxns.forEach((section) => {
            // const shortKey = key.slice(key.indexOf(':') + 1);
            // if (props.uiState.openSections.has(shortKey)) {
            processTxnList(props, headers, data, section);
            // }
        });
    }
    return { headers, data };
};
const convertToFile = (headers, data) => {
    // This special prepend is a flag to microsoft EXCEL to use UTF-8 in importing
    // which is required for currency symbols that are multi-byte
    let str = '\uFEFF';
    headers.forEach((x) => { str = `${str},${x}`; });
    str = `${str}\n`;
    data.forEach((x) => {
        x.forEach((y) => {
            str = `${str},${y}`;
        });
        str = `${str}\n`;
    });
    return new Blob([str], { type: 'text/csv; charset=utf-8' });
};
// Download the current view to a CSV file
const downloadRegisterToCSV = (props) => {
    var _a;
    const { headers, data } = convertRegViewToArrays(props);
    const filename = `${(0, utils_2.capitalize)((_a = props === null || props === void 0 ? void 0 : props.dataset) === null || _a === void 0 ? void 0 : _a.name)}_transactions_${luxon_1.DateTime.now().toFormat('ddMMMyy')}.csv`;
    if (headers && data) {
        const csvData = convertToFile(headers, data);
        // @ts-expect-error - FIXME: Property 'msSaveBlob' does not exist on type 'Navigator'.ts(2339)
        if (navigator.msSaveBlob) {
            // @ts-expect-error - FIXME: Property 'msSaveBlob' does not exist on type 'Navigator'.ts(2339)
            navigator.msSaveBlob(csvData, filename);
        }
        else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(csvData);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
exports.downloadRegisterToCSV = downloadRegisterToCSV;
const txnListMetrics = (acctTxns) => {
    let numTxns = 0;
    let sumTxns = 0;
    let earliestDate = luxon_1.DateTime.now();
    let reviewedCount = 0;
    acctTxns.forEach((section, _) => {
        numTxns += section.size;
        section.forEach((txn) => {
            sumTxns += Number(txn.amount);
            const postedOn = luxon_1.DateTime.fromISO(txn.postedOn);
            if (postedOn < earliestDate) {
                earliestDate = postedOn;
            }
            reviewedCount += (txn.isReviewed ? 1 : 0);
        });
    });
    return { numTxns, sumTxns, earliestDate, reviewedCount };
};
exports.txnListMetrics = txnListMetrics;
/**
 * This is a filter factory that builds a filtering function from
 * an expression. Lodash memoizer ensures that for the same expression
 * string, the same function instance is always returned. This allows
 * the function to be passed to a reselector and not bust the cache.
 *
 * This could be considered a leak in the sense that a function
 * will be preserved for each filter expression a user executes, but practically
 * that will be bounded by the duration of the session. The backing map
 * implementation could probably be swapped out if this turns out to
 * be an issue.
 */
exports.createFilterFromExpression = lodash_1.default.memoize((expression) => {
    if (expression) {
        return (txns) => (0, searchFilter_1.filterTransactionsByExpression)(txns, expression);
    }
    return null;
});
exports.createFilterFromFilterObject = lodash_1.default.memoize((filterObject) => {
    if (filterObject) {
        return (txns) => (0, searchFilter_1.filterTransactionsByFilterObject)(txns, filterObject);
    }
    return null;
});
const filterFromObjectAndExpression = (txns, filterObject, filterExpression) => {
    let newTxns = txns;
    if (newTxns && filterObject) {
        newTxns = (0, searchFilter_1.filterTransactionsByFilterObject)(newTxns, filterObject);
    }
    if (newTxns && filterExpression && filterExpression.length > 0) {
        newTxns = (0, searchFilter_1.filterTransactionsByExpression)(newTxns, filterExpression);
    }
    return newTxns;
};
const createFilterFromObjectAndExpression = (filterObject, filterExpression) => {
    const cacheObject = {
        filterObject,
        filterExpression,
    };
    return (0, memoizeWithKey_1.memoizeWithObjectKey)('registerFilters', () => (txns) => filterFromObjectAndExpression(txns, filterObject, filterExpression), cacheObject, 20);
};
exports.createFilterFromObjectAndExpression = createFilterFromObjectAndExpression;
